// src/pages/PostIntent.jsx
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function PostIntent() {
  const history = useHistory();

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const url   = (sp.get("url") || "").trim();
    const title = (sp.get("title") || "").trim();
    const text  = (sp.get("text") || "").trim();

    // Header → Create モーダルへ受け渡す（最小改修のため一時的にグローバル）
    window.__nl_intent_url = url;
    window.__nl_intent_text = [title, text].filter(Boolean).join(" ");

    // Home に戻してモーダルを開く
    history.replace("/home?openPost=1");
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("nl:open-post-intent"));
    }, 0);
  }, [history]);

  return null;
}
